/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/proscenium/"

const PROSCENIUM: CommunityData = {
  code: "proscenium",
  inviteCode: "proscenium",
  name: "Proscenium",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/pro-018`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[190px] h-[48px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[190px] h-[48px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "",
      asideStyles: "border-r border-[#444444]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      mainFont: "font-['InterRegular']",
      primaryButton:
        "bg-[#000000cc] border border-[#41fef6] px-[18px] py-[18px] !text-[#41fef6] font-['SpaceMonoRegular'] !text-[15px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#444444]",
      item: "font-['SpaceMonoRegular'] text-[15px] text-[#ffffff] uppercase text-center leading-[100%] gap-x-[10px] text-opacity-50 border-b border-[#444444] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#444444] rounded-[16px] !pb-8",
      titles:
        "text-[#ffffff] font-['RamaGothicMBold'] text-[34px] uppercase text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#41fef6] font-['SpaceMonoRegular'] text-[12px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#ffffff] font-['RamaGothicMBold'] text-[34px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer:
            "w-full sm:w-[256px] !aspect-square relative rounded-[12px] overflow-hidden",
          media: "w-full !aspect-square object-cover rounded-[12px]",
          placeholderMedia: "w-full !aspect-square bg-gray-400 rounded-[12px]",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['RamaGothicESemiBold'] text-[26px] uppercase text-left leading-[100%]",
          subtitle:
            "text-[#41fef6] font-['SpaceMonoRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#ffffff] font-['RamaGothicMBold'] text-[34px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[440px] h-full overflow-hidden bg-[#000000]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 relative rounded-[12px] overflow-hidden",
          media: "w-full !aspect-video object-cover rounded-[12px]",
          placeholderMedia: "w-full !aspect-video bg-gray-400 rounded-[12px]",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left leading-[100%]",
          subtitle:
            "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] text-left leading-[120%] mt-2",
          location:
            "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] text-left leading-[120%] mt-1",
          date: "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['RamaGothicMBold'] text-[28px] uppercase text-left leading-[100%]",
        text: "text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "rounded-[12px]",
        sectionTitle:
          "text-[#ffffff] font-['RamaGothicMBold'] text-[34px] uppercase text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: "",
        mobile: "",
        style: "bg-[#000000]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-logo.png`,
        mobile: `${S3_PREFIX}web-logo.png`,
        style: "w-[190px] h-[48px] object-contain",
      },
      werzLogoColor: "#ffffff",
      title: "text-[#ffffff] font-['RamaGothicMBold'] text-[34px] uppercase leading-[100%]",
      text: "text-[#ffffff] font-['SpaceMonoRegular'] text-[12px] leading-[120%]",
      button:
        "bg-[#000000cc] border border-[#41fef6] px-[18px] py-[18px] cursor-pointer w-fit text-[#41fef6] font-['SpaceMonoRegular'] text-[15px] uppercase leading-[100%]",
      input: {
        base: "font-['SpaceMonoRegular'] text-[12px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#000000] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['SpaceMonoRegular'] text-[12px] leading-[120%] text-[#FF0000]",
      footerText: "text-[#41fef6] font-['SpaceMonoRegular'] text-[12px] leading-[120%]",
      skipButton:
        "text-[#41fef6] font-['SpaceMonoRegular'] text-[12px] leading-[120%] cursor-pointer",
      modal: {
        container: "bg-[#111111] px-[40px] py-[48px]",
        title:
          "font-['RamaGothicMBold'] text-[28px] uppercase leading-[100%] text-[#ffffff] text-center",
        text: "text-[#41fef6] font-['SpaceMonoRegular'] text-[12px] leading-[120%] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center text-[#ffffff] bg-[#000000]",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    linktree: {
      bgDesktop: "",
      bgMobile: "",
      bgColor: "#000000",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#000000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border-[#444444]",
        name: "text-[#ffffff] font-['RamaGothicMBold'] text-[34px] uppercase text-center mt-4 mb-1 leading-[100%]",
        location:
          "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-center mb-2 leading-[100%]",
        description:
          "text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#ffffff",
        button:
          "bg-[#000000] border-2 border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SpaceMonoRegular'] text-[11px] uppercase text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] rounded-[16px] text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#000000] border border-[#444444] rounded-[16px]",
          title:
            "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-center mb-1 leading-[100%]",
          text: "text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center",
          button:
            "bg-[#000000] border-2 border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SpaceMonoRegular'] text-[11px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-center mb-[10px] leading-[100%]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444] rounded-[8px]",
          duration: "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] leading-[120%] text-left",
          name: "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw] leading-[100%]",
          plusIconColor: "#ffffff",
          media: "overflow-hidden m-2 border border-[#444444] rounded-[12px]",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#000000] border border-[#444444] rounded-[8px]",
          name: "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw] leading-[100%]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#ffffff] text-[#000000] font-['RamaGothicESemiBold'] text-[18px] uppercase text-center leading-[100%]",
          duration: "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] leading-[120%] text-left",
          location: "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] leading-[120%] text-left",
          button:
            "bg-[#000000] border-2 border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SpaceMonoRegular'] text-[11px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#444444]",
            name: "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw] leading-[100%]",
            price:
              "text-[#41fef6] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left leading-[100%]",
            link: "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] leading-[120%] text-left",
            status:
              "text-[#41fef6] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left leading-[100%]",
            button:
              "bg-[#000000] border-2 border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SpaceMonoRegular'] text-[11px] uppercase text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] rounded-[16px] text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-center mb-[10px] leading-[100%]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444] rounded-[8px]",
          name: "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw] leading-[100%]",
          triangleIconColor: "#ffffff",
          created: "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] leading-[120%] text-left",
          media: "overflow-hidden m-2 border border-[#444444] rounded-[12px]",
        },
        seeAllNews:
          "text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] rounded-[16px] text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-center mb-[10px] leading-[100%]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444] rounded-[8px]",
          coverUrl: "overflow-hidden m-2 border border-[#444444] rounded-[12px]",
          duration: "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] leading-[120%] text-left",
          liveType: "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] leading-[120%] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#41fef6] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#ffffff",
          playIconBorderColor: "#000000",
          start: "text-[#41fef6] font-['SpaceMonoRegular'] text-[11px] leading-[120%] text-left",
          title:
            "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw] leading-[100%]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] rounded-[16px] text-[#ffffff] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-center mb-[10px] leading-[100%]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444] rounded-[8px]",
          name: "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left leading-[100%]",
          triangleIconColor: "#ffffff",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#444444]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border border-[#444444] rounded-[16px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#444444]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 rounded-[12px]",
        title:
          "text-[#ffffff] font-['RamaGothicMBold'] text-[34px] uppercase text-left leading-[100%]",
        subtitle:
          "text-[#41fef6] font-['SpaceMonoRegular'] text-[12px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#000000cc] border border-[#41fef6] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#41fef6] font-['SpaceMonoRegular'] !text-[15px] uppercase text-left leading-[100%]",
        questions: "text-[12px] text-left leading-[120%] text-[#41fef6]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['RamaGothicMBold'] text-[28px] uppercase text-left leading-[100%]",
        text: "text-[#ffffff] font-['SpaceMonoRegular'] text-[12px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['RamaGothicMBold'] text-[28px] uppercase text-left leading-[100%]",
        text: "text-[#ffffff] font-['SpaceMonoRegular'] text-[12px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "h-[206px] overflow-hidden border border-[#444444] gap-y-[10px] rounded-[16px]",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['RamaGothicMBold'] text-[28px] uppercase text-left leading-[100%]",
        text: "text-[#ffffff] font-['SpaceMonoRegular'] text-[12px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['RamaGothicMBold'] text-[28px] uppercase text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border-2 border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SpaceMonoRegular'] text-[11px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#000000] border-b border-[#444444] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left leading-[100%] mb-1",
          description:
            "text-[#41fef6] font-['SpaceMonoRegular'] text-[12px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#41fef6] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left leading-[100%]",
          quantity:
            "text-[#ffffff] font-['SpaceMonoRegular'] text-[11px] uppercase text-left leading-[100%]",
          status:
            "text-[#41fef6] font-['RamaGothicESemiBold'] text-[18px] uppercase text-left leading-[100%]",
          counterContainer:
            "bg-[#000000] border-2 border-[#ffffff] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border-2 border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SpaceMonoRegular'] text-[11px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default PROSCENIUM
